module.exports = __webpack_public_path__ + "static/media/Testemonials.a2e907fd.svg";